import { render } from "./Header.vue?vue&type=template&id=35c9e18a&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=35c9e18a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-35c9e18a"

export default script